
/**
 * Created by Yoyo Fang on 05/05/2019.
 * Description:
 * ------ maintenance history ------
 */
import { Subject } from 'rxjs';

export class EntityConfig {
    constructor(public embedMode: boolean = false) {
        this.actionSubject$ = new Subject<EntityAction>();
        this.feedbackSubject$ = new Subject<EntityFeedbackAction>();
    }
    public actionSubject$: Subject<EntityAction>;
    public feedbackSubject$: Subject<EntityFeedbackAction>;
}

export class EntityAction {
    constructor(public type: EntityActionTypes, public payload: any) { }
}

export class EntityFeedbackAction {
    constructor(public type: EntityFeedbackTypes, public payload: any) { }
}

export enum EntityActionTypes {
    SWITCH_ANOTHER_ENTITY = 'SWITCH_ANOTHER_ENTITY',
    SIDE_SHEET = 'SIDE_SHEET'
}

export enum EntityFeedbackTypes {
    ENTITY_LOADED = 'ENTITY_LOADED',
    ENTITY_UPDATED = 'ENTITY_UPDATED'
}

export enum EntityAssociatedType {
    ENTRY = 'ENTRY',
    RELATIONSHIP = 'RELATIONSHIP',
    ENTITY = 'ENTITY',
    TEAM = 'TEAM',
    CONFIG = 'CONFIG'
}

export enum SourceType {
    ENTITY = 'Entity',
    CONTACT = 'Contact',
    USER = 'User'
}
